/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Radio from '@material-ui/core/Radio';

// Actions
import * as CompaniesActions from 'store/ducks/companies/actions';

// Types
import { ApplicationState } from 'store';

// Constants
import CONST_TRANSPORT_VOUCHER_COLLECTION from 'constants/transportVoucherCollectionReport';

// Styles
import useStyles from './statusFilter.styles';

const StatusFilter: React.FC = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const selectedStatus = useSelector(
    (state: ApplicationState) => state.companies.selectedStatus,
  );

  const handleStatus = (key: number) => {
    const selected = selectedStatus === key;

    dispatch(
      CompaniesActions.setSelectedStatus({
        selectedStatus: selected ? '' : key,
      }),
    );
  };

  return (
    <List dense>
      {CONST_TRANSPORT_VOUCHER_COLLECTION.STATUS.map(({ KEY, VALUE }) => (
        <ListItem key={KEY} button>
          <ListItemText
            id={VALUE}
            primary={VALUE}
            onClick={() => handleStatus(KEY)}
            classes={{ root: classes.itemText }}
          />
          <ListItemSecondaryAction>
            <Radio
              edge='end'
              name={VALUE}
              color='primary'
              onClick={() => handleStatus(KEY)}
              checked={selectedStatus === KEY}
              inputProps={{ 'aria-labelledby': VALUE }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export { StatusFilter };
export default StatusFilter;
